module.exports = __webpack_public_path__ + "static/media/LogicWedge1_5_4.ffe0c792.png";